import React from 'react';
import { getIntl } from '../../../../utils/intl';
import Text from '../../../v2BaseComponents/Text';
import Button from '../../../v2BaseComponents/Button';
import { View } from 'react-native';
import { getSpacing } from '../../../../utils/spacing';
import { colors } from '../../../../utils/theme';
import Stack from '../../../v2BaseComponents/Stack';

const intl = getIntl('ExpandableInformationSection', {
    readMore: 'Read More',
    showLess: 'Show Less',
});

type ExpandableInformationSectionProps = {
    renderExpandedContent: () => React.ReactNode;
    renderCollapsedContent: () => React.ReactNode;
    title: string;
};

const ExpandableInformationSection: React.FC<ExpandableInformationSectionProps> = ({
    renderCollapsedContent,
    renderExpandedContent,
    title,
}) => {
    const [expanded, setExpanded] = React.useState(false);

    return (
        <View
            style={{
                width: '100%',
                borderWidth: 1,
                borderRadius: 8,
                borderColor: colors['Paper-Border'],
                paddingHorizontal: getSpacing(12),
                paddingVertical: getSpacing(14),
                backgroundColor: colors['White'],
            }}
        >
            <Stack space={getSpacing(4)} vertical>
                <Text
                    variant="h3"
                    style={{
                        fontFamily: 'SuisseWorksBold',
                        fontSize: 20,
                        lineHeight: 26,
                        letterSpacing: 0,
                    }}
                >
                    {title}
                </Text>
                {expanded ? renderExpandedContent() : renderCollapsedContent()}
                <Button
                    variant="text"
                    onPress={() => setExpanded((prevValue) => !prevValue)}
                    title={expanded ? intl('showLess') : intl('readMore')}
                    icon={!expanded ? 'ArrowRight3' : undefined}
                    size="sm"
                />
            </Stack>
        </View>
    );
};

export default React.memo(ExpandableInformationSection);
